import './smartroom.css'
import '../projectscontent.css'
import { TypingText } from "../../../../components/glowingtextcomponet/typingtext.js";

export const SmartRoom = () => (
    <div>
        <TypingText content='Coming Soon.' />
    </div>
);
